import { render, staticRenderFns } from "./Hcucineo.vue?vue&type=template&id=b3bdb8e2"
import script from "./Hcucineo.vue?vue&type=script&lang=js"
export * from "./Hcucineo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports